import React from "react";
import styled from "styled-components";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

// layouts
import { MainLayout } from "layouts";

// components
import { Button } from "components/common";
import PasswordField from "components/form/PasswordField";
import { patchPasscode } from "api/user";

const EditPassword = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.user);
  const initialValues = {
    password: "",
    passwordConfirm: "",
  };

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string().matches(
      /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*.]{8,16}$/,
      "8자 이상 숫자와 영어를 포함해서 입력해주세요"
    ),
    passwordConfirm: Yup.string()
      .oneOf([Yup.ref("password")], "새로운 비밀번호가 일치하지 않습니다")
      .required("새로운 비밀번호를 다시 입력해 주세요"),
  });

  const handleClickButton = (values) => {
    patchPasscode({
      phoneNumber: userInfo.phoneNumber,
      oldPassCode: userInfo.oldPassCode,
      passCode: values.password,
    })
      .then((result) => {
        if (result) {
          navigate(-2);
        }
      })
      .catch((e) => {});
  };

  const handlePasswordConfirmKeyUp = (e, formik) => {
    const currentConfirmValue = e.target.value;

    if (currentConfirmValue === formik.values.password) {
      // 비밀번호가 일치하면 에러를 지워줍니다
      formik.setFieldError("passwordConfirm", undefined);
      // 전체 폼 유효성을 다시 검사합니다
      formik.validateForm();
    }
  };

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "비밀번호 변경" }}
    >
      <Wrapper>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={true}
          onSubmit={(values) => handleClickButton(values)}
        >
          {(formik) => (
            <Form>
              <PasswordField
                name="newPassword"
                label="새로운 비밀번호"
                placeholder="새로운 비밀번호"
                withInstruction={true}
                instructionMsg={"8자 이상 숫자와 영어를 포함해서 입력해주세요"}
                maxLength={30}
              />

              <PasswordField
                name="passwordConfirm"
                label="새로운 비밀번호 확인"
                maxLength={30}
                placeholder="새로운 비밀번호 확인"
                onKeyUp={(e) => handlePasswordConfirmKeyUp(e, formik)}
              />

              <BottomButtonWrapper>
                <Button
                  variant="contained"
                  className="square"
                  padding="16px"
                  text="비밀번호 변경"
                  disabled={
                    !formik.values.password ||
                    !formik.values.passwordConfirm ||
                    formik.errors.password ||
                    formik.errors.passwordConfirm
                  }
                  type="submit"
                />
              </BottomButtonWrapper>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 20px 0px 20px;

  div:first-child {
    margin-bottom: 18px;
  }
`;

const BottomButtonWrapper = styled.div`
  display: flex;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 40px;
`;

export default EditPassword;
